import React, { PureComponent } from 'react';
import InputColor from 'react-input-color';
import { getHexColor } from 'src/util/misc';

interface EngravingProps {
    id: string;
    isEngraving: boolean;
    colorEngraving: string;
    changeEngravingColor: (data: { id: string; color: string }) => void;
}

export default class Engraving extends PureComponent<EngravingProps> {
    render() {
        const { id, isEngraving, changeEngravingColor, colorEngraving } = this.props;

        const handleChange = (evt: { hex: string }) => {
            changeEngravingColor({ id, color: getHexColor(evt.hex) });
        };

        return isEngraving ? (
            <div className='blending'>
                <h3>Engraving Settings</h3>
                <div className='blending__engraving-color-wrapper'>
                    <span>Engraving Color</span>
                    <InputColor initialValue={colorEngraving} onChange={handleChange} placement='top' />
                </div>
            </div>
        ) : null;
    }
}
